import nflFranchises from "../data/nflFranchises.json";
import { MIN_DIRECTORY_QUERY_LENGTH } from "../components/playerSearch/playerSearchCatalog";

export const getActiveNflFranchises = () => nflFranchises.active || [];

function aliasNames(franchise) {
  return (franchise.aliases || []).map((alias) =>
    typeof alias === "string" ? alias : alias.name
  );
}

function franchiseDisplayNames(franchise) {
  return [franchise.name, ...aliasNames(franchise)].filter(Boolean);
}

function franchiseAbbrs(franchise) {
  return [franchise.id, ...(franchise.abbrs || [])].map((value) =>
    String(value).toUpperCase()
  );
}

function matchFranchiseName(label) {
  const needle = String(label || "").trim().toLowerCase();
  if (!needle) return "";
  const match = getActiveNflFranchises().find((franchise) =>
    franchiseDisplayNames(franchise).some(
      (name) => String(name).toLowerCase() === needle
    )
  );
  return match?.id || "";
}

function nameBeforeLeague(label) {
  const match = String(label || "").match(/^(.+?)\s*\((?:NFL|AFL|AAFC)\)/i);
  if (!match) return "";
  return match[1].replace(/^\d{4}\s+/, "").trim();
}

export function nflFranchiseIdFromAbbr(abbr) {
  const token = String(abbr || "").toUpperCase();
  if (!token) return "";
  const match = getActiveNflFranchises().find((franchise) =>
    franchiseAbbrs(franchise).includes(token)
  );
  if (match) return match.id;
  return /^(?:[A-Z]{2,4}|[23]TM)$/.test(token) ? token : "";
}

export function nflTeamAbbrFromLabel(label) {
  const text = String(label || "").trim();
  if (!text) return "";
  if (/^(?:[A-Za-z]{2,4}|[23]TM)$/i.test(text)) {
    return nflFranchiseIdFromAbbr(text);
  }

  const fromLeagueName = matchFranchiseName(nameBeforeLeague(text));
  if (fromLeagueName) return fromLeagueName;

  return matchFranchiseName(text);
}

export function getNflFranchise(franchiseId) {
  const id = String(franchiseId || "").toUpperCase();
  if (!id) return null;
  return (
    getActiveNflFranchises().find((franchise) => franchise.id === id) || null
  );
}

function franchiseSearchNames(franchise) {
  return [franchise.id, franchise.name, ...aliasNames(franchise)].filter(Boolean);
}

export function filterNflFranchises(franchises = [], query = "") {
  const needle = String(query).trim().toLowerCase();
  if (needle.length < MIN_DIRECTORY_QUERY_LENGTH) return [];
  return franchises
    .filter((franchise) =>
      franchiseSearchNames(franchise).some((name) =>
        String(name).toLowerCase().includes(needle)
      )
    )
    .map((franchise) => ({
      id: franchise.id,
      label: franchise.name,
    }));
}

export function railTeamsFromNflFranchises(franchises = []) {
  return franchises
    .filter((franchise) => franchise.active !== false)
    .map((franchise) => ({
      id: franchise.id,
      name: franchise.name,
      sport: "nfl",
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
